export const getTipoUsuario = (codTipoUsrContr: string): string => {
  switch(codTipoUsrContr) {
      case "TITULA":
          return "Titular";
      case "DEPEND":
          return "Dependente";
      case "AGREGA":
          return "Agregado";
      default:
          return codTipoUsrContr;
  }
}
